import React, {Component} from 'react';
import {Form, Timeline} from "antd";
import BaseComponent from "../../../../base/BaseComponent";
import {formatDate} from "../../../../utils";

// 流程回复展示（审核意见）
class ProcessRemarkDetails extends BaseComponent {

    constructor(props) {
        super(props);
        this.getHistoryData(props.data);
        this.state = {
            remarkList:[],
            label: props.label || "",
            maxWidth: props.maxWidth || 650,
        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.getHistoryData(nextProps.data);
    }
    getHistoryData(id){
        if(id&&id.length>1){
            this.request({
                url : "/cm-sites-sys/process/getProcessHistory",
                body:{bizKey:`${id}`},
                callBack: (list)=>{
                    let remarkList = [];
                    for(let i = 0 ; list && i < list.length; i++){
                        let item = list[i];
                        if(item && item.otherData && item.otherData.remarks){
                            let remarks = item.otherData.remarks;
                            if(typeof remarks === "string"){
                                remarkList.push({
                                    operatorName: item.operatorName,
                                    updateTime: formatDate(item.updateTime),
                                    info: remarks,
                                });
                            }
                        }
                    }
                    if(remarkList.length > 0){
                        this.setState({remarkList});
                    }
                }
            })
        }
    }

    render() {
        if(this.state.remarkList.length === 1){
            let remark = this.state.remarkList[0];
            return <div style={{display:"inline-block"}}>
                <table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{margin:"10px 0"}}><tbody><tr>
                    <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                        {this.state.label}：
                    </td>
                    <td style={{width:this.state.maxWidth, color:"#252424",wordBreak:'break-all'}} valign={"top"}>
                        {remark.operatorName}：{remark.info}
                        <div style={{float:"right",marginRight:"10px"}}>{remark.updateTime}</div>
                    </td>
                </tr></tbody></table>
            </div>;
        }
        let result =true;

        if(this.props.condition&&this.props.condition.length){
            if(this.props.condition.indexOf(this.props.dataSource.status)> -1){
                result = false
            }
        }
        return <div style={{width:"100%"}}>
            {result?<table cellPadding={0} cellSpacing={0} border={0} width={"100%"} style={{margin:"10px 0"}}><tbody><tr>
                <td width={100} align={"right"} valign={"top"} style={{color: "#aaa6a6"}}>
                    {this.state.label}：
                </td>
                <td style={{width:this.state.maxWidth, color:"#252424", paddingTop:7,wordBreak:'break-all'}} valign={"top"}>
                    <Timeline>
                        {this.state.remarkList.map((remark, index)=>{
                            return <Timeline.Item key={index}>
                                <span style={{color: "#aaa6a6"}}>{remark.updateTime}</span><br/>
                                {remark.operatorName}：{remark.info}
                            </Timeline.Item>
                        })}
                    </Timeline>
                </td>
            </tr></tbody></table>:null}

        </div>

    }
}

{/*<div style={{maxWidth:650}}>*/}
{/*    {remark.operatorName}：{remark.info}*/}
{/*</div>*/}
{/*<div style={{float:"right",lineHeight:"40px",marginRight:"10px"}}>{remark.updateTime}</div>*/}

export default ProcessRemarkDetails;
